import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import type { ThemeMode } from '../../../src/theme/ThemeContext';

export const getTeamCrestStyles = (theme: Theme, themeMode: ThemeMode = 'light', size = 40) => {
  const isDark = themeMode === 'dark';

  return StyleSheet.create({
    root: {
      width: size,
      height: size,
      alignItems: 'center',
      justifyContent: 'center',
    },
    logo: {
      width: size,
      height: size,
    },
    monogram: {
      width: size,
      height: size,
      borderRadius: size / 2,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: isDark ? theme.gray[300] : theme.gray[200],
      borderWidth: 1,
      borderColor: isDark ? theme.gray[400] : theme.gray[300],
    },
    monogramText: {
      fontSize: Math.max(10, Math.round(size * 0.38)),
      fontWeight: '800',
      color: theme.gray[700],
      letterSpacing: 0.5,
    },
  });
};
